var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-card"},[_c('v-card',{attrs:{"height":"60"}},[_c('v-footer',{staticClass:"white",attrs:{"absolute":""}},[_c('v-col',{staticClass:"text-center",staticStyle:{"color":"#555555","font-size":"13px"},attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(new Date().getFullYear())+" © "),_c('strong',[_vm._v("Version 1.1.2")])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }